import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { LoginResponse } from '@models/swagger';
import { RefreshLoginFailure, RefreshLoginRequest, RefreshLoginReset, RefreshLoginSuccess } from './actions';

export const featureKey = 'refreshLogin';

export interface State {
  data: LoginResponse | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(RefreshLoginFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(RefreshLoginRequest, state => ({ ...state, error: null, loading: true })),
    on(RefreshLoginSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(RefreshLoginReset, state => ({ ...state, data: null, error: null, loading: false }))
  )(state, action);
}
